import React from 'react';

import { useIntl } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import { buildCategoryBreadcrumbs } from './categoryBreadcrumbs';

import css from './SectionCategoryBreadcrumbs.module.css';

/**
 * Category / subcategory breadcrumb trail under the listing title.
 * Links each crumb into Search with listing type + cumulative category params.
 *
 * @component
 */
const SectionCategoryBreadcrumbs = props => {
  const { publicData, categoryConfiguration } = props;
  const intl = useIntl();
  const crumbs = buildCategoryBreadcrumbs(publicData, categoryConfiguration);

  if (!crumbs.length) {
    return null;
  }

  return (
    <nav
      className={css.root}
      aria-label={intl.formatMessage({ id: 'ListingPage.categoryBreadcrumbsAriaLabel' })}
    >
      <ol className={css.list}>
        {crumbs.map((crumb, index) => (
          <li key={`${index}-${crumb.id}`} className={css.item}>
            {index > 0 ? (
              <span className={css.separator} aria-hidden="true">
                /
              </span>
            ) : null}
            <NamedLink name="SearchPage" to={{ search: crumb.search }} className={css.link}>
              {crumb.label}
            </NamedLink>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default SectionCategoryBreadcrumbs;
